import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-drivingDifficultyIceIcon",
  "use": "icon-drivingDifficultyIceIcon-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-drivingDifficultyIceIcon\"><path d=\"M2.965 2.676h10.667L12.35 10l-2-3.333-2 7.333-1.667-9.333-2 7-1.72-8.991Z\" stroke=\"#4C556C\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><rect x=\"1.352\" y=\"2\" width=\"14\" height=\"1.33\" rx=\".665\" fill=\"#4C556C\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol